




















import { Component, Vue, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { User } from "shared/store/auth/types";
import { namespace } from "vuex-class";
import { getImpersonateLink } from "../api";

const snackStore = namespace("snackbar");

@Component
export default class ImpersonateButton extends Vue {
  @Prop({ required: true, type: Object }) readonly user!: User;
  @snackStore.Mutation defaultError!: () => void;

  dialog = false;
  link = "";

  get fullName(): string {
    if (this.user.first_name === "") return this.user.last_name;
    return this.user.first_name + " " + this.user.last_name;
  }

  async generate(): Promise<void> {
    try {
      const res = await getImpersonateLink(this.user.id);
      this.link = res.link;
    } catch (e) {
      this.defaultError();
    }
  }

  copy(): void {
    var textArea = document.createElement("textarea");
    textArea.value = this.link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();
  }

  private t(key: string, values?: VueI18n.Values): string {
    return this.$t(
      "base.components.impersonateButton." + key,
      values
    ).toString();
  }
}
